/* ==========================================================
   Floating Product Video
   Version 1.0
   Compatible: Shopify Dawn
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const wrapper = document.querySelector(".fpv-wrapper");

    if (!wrapper) return;

    // Wait 2 seconds before showing
    setTimeout(() => {

        if (localStorage.getItem("fpv_closed") !== "true") {

            wrapper.classList.add("show");

        }

    }, 2000);

    const minimizeBtn = wrapper.querySelector(".fpv-minimize");
    const closeBtn = wrapper.querySelector(".fpv-close");
    const pill = wrapper.querySelector(".fpv-pill");
    const video = wrapper.querySelector("video");

    /* ----------------------------
       Minimize
    ----------------------------- */

    if (minimizeBtn) {

        minimizeBtn.addEventListener("click", () => {

            wrapper.classList.toggle("fpv-minimized");

        });

    }

    /* ----------------------------
       Restore
    ----------------------------- */

    if (pill) {

        pill.addEventListener("click", () => {

            wrapper.classList.remove("fpv-minimized");

        });

    }

    /* ----------------------------
       Close
    ----------------------------- */

    if (closeBtn) {

        closeBtn.addEventListener("click", () => {

            wrapper.classList.add("fpv-close-animation");

            localStorage.setItem("fpv_closed","true");

            setTimeout(() => {

                wrapper.remove();

            },300);

        });

    }

    /* ----------------------------
       Pause when tab hidden
    ----------------------------- */

    document.addEventListener("visibilitychange", () => {

        if (!video) return;

        if (document.hidden) {

            video.pause();

        } else {

            video.play().catch(()=>{});

        }

    });

    /* ----------------------------
       Pause when user scrolls
       video outside viewport
    ----------------------------- */

    if ("IntersectionObserver" in window && video) {

        const observer = new IntersectionObserver((entries)=>{

            entries.forEach(entry=>{

                if(entry.isIntersecting){

                    video.play().catch(()=>{});

                }else{

                    video.pause();

                }

            });

        });

        observer.observe(wrapper);

    }

    /* ----------------------------
       Mobile Drag (future ready)
    ----------------------------- */

    let isDragging=false;

    let startX=0;
    let startY=0;

    let currentX=0;
    let currentY=0;

    wrapper.addEventListener("pointerdown",(e)=>{

        if(
            e.target.closest(".fpv-btn") ||
            e.target.closest("video") ||
            e.target.closest("iframe")
        ) return;

        isDragging=true;

        startX=e.clientX-currentX;
        startY=e.clientY-currentY;

        wrapper.style.transition="none";

    });

    document.addEventListener("pointermove",(e)=>{

        if(!isDragging) return;

        currentX=e.clientX-startX;
        currentY=e.clientY-startY;

        wrapper.style.transform=
        `translate(${currentX}px,${currentY}px)`;

    });

    document.addEventListener("pointerup",()=>{

        if(!isDragging) return;

        isDragging=false;

        wrapper.style.transition="all .35s ease";

    });

});